import Gameplay from 'pages/Gameplay';

function App() {
  return (
    <Gameplay />
  );
}

export default App;
